module.exports = __webpack_public_path__ + "static/media/coffee-promo-mb-en.aff9d0ed.mp4";